import _ from 'lodash';

export const extractMessageFromException = (err: any) => {
  const error = err.body?.message ?? err.message ?? 'An error occurred';
  return _.capitalize(error);
};
